"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../icon/Icon"));

var _Banner = require("./Banner.style");

var _excluded = ["color", "iconName", "description", "buttons"];

var Banner = function Banner(_ref) {
  var color = _ref.color,
      iconName = _ref.iconName,
      description = _ref.description,
      buttons = _ref.buttons,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Banner.StyledBanner, (0, _extends2["default"])({}, props, {
    color: color
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "banner-content d-flex"
  }, iconName && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    iconName: iconName,
    size: 24,
    color: color,
    shade: 'c02',
    style: {
      marginRight: '12px'
    }
  }), description && /*#__PURE__*/_react["default"].createElement(_Banner.StyledDesc, null, description)), buttons && /*#__PURE__*/_react["default"].createElement(_Banner.StyledButtonHolder, null, buttons));
};

Banner.defaultProps = {
  color: 'primary',
  iconName: 'Info',
  shadow: false
};
Banner.propTypes = {
  className: _propTypes["default"].string,
  color: _propTypes["default"].oneOf(['primary', 'secondary', 'info', 'error', 'success', 'warning']),
  iconName: _propTypes["default"].string,
  description: _propTypes["default"].string,

  /**
   * eg: `<>
   * <Button variant='plain'>Button</Button>
   * <Button variant='outlined' ml={2}>Button</Button>
   * </>`
   */
  buttons: _propTypes["default"].node,
  shadow: _propTypes["default"].bool
};
var _default = Banner;
exports["default"] = _default;